import { render } from "./CreateStrategyContent.vue?vue&type=template&id=b4869d06&lang=true"
import script from "./CreateStrategyContent.vue?vue&type=script&lang=js"
export * from "./CreateStrategyContent.vue?vue&type=script&lang=js"
script.render = render

export default script